import { Injectable } from '@angular/core';
import { Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthRole, AuthService } from '@app/modules/auth';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AffiliateGuard  {

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isValid();
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return this.isValid();
  }

  /**
   * Only Allow opening affiliate pages if user has not logged in and is affiliate.
   * If authenticated redirect to login instead.
   *
   * @returns true if user is affiliate.
   */
  isValid() {
    if (this.authService.isAuthenticated &&
      (this.authService.accessTokenObj.role === AuthRole.BUSINESSPARTNER || this.authService.accessTokenObj.role === AuthRole.SUPERDEALER) ) {
      return true;
    }

    this.router.navigate(['/auth']);
    return true;
  }
}
